import React from 'react';
import DriversTable from './DriversTable';

export default function AllowPayoutDrivers() {
  return <DriversTable title="Allow instant payout" orderByChild="allowPayout" equalTo={true} />;
}
